import { RealtimeMessageType, type RealtimeEvent } from '@gr/core/platform/system/realtime';
import type { TaskDto } from '@gr/core/platform/tasks/dto';
import { Observable } from '../../../../shared/store';

/**
 * TASK-UC-2, TASK-UC-2.CC-1: задачи, которые знает вкладка, — по соединению событий и из ответов
 * API. Снимок на подписку заменяет задачи своего блога и платформы; изменение — одну задачу, если
 * оно не старее известного.
 */
export class TaskStore {
  readonly tasks = new Observable<ReadonlyMap<string, TaskDto>>(new Map());

  apply(message: RealtimeEvent): void {
    if (message.type === RealtimeMessageType.Tasks) this.replaceScope(message.blogId, message.tasks);
    else if (message.type === RealtimeMessageType.TaskChanged) this.merge([message.task]);
  }

  /** Задачи из ответов API (список, отмена, возобновление) — те же правила новизны. */
  merge(tasks: readonly TaskDto[]): void {
    const next = new Map(this.tasks.get());
    let changed = false;
    for (const task of tasks) {
      const known = next.get(task.id);
      if (known && known.updatedAt > task.updatedAt) continue;
      next.set(task.id, task);
      changed = true;
    }
    if (changed) this.tasks.set(next);
  }

  /** Выход пользователя: чужие задачи следующему не достаются. */
  clear(): void {
    this.tasks.set(new Map());
  }

  private replaceScope(blogId: string | null, tasks: readonly TaskDto[]): void {
    const next = new Map([...this.tasks.get()].filter(([, task]) => task.blogId !== null && task.blogId !== blogId));
    for (const task of tasks) next.set(task.id, task);
    this.tasks.set(next);
  }
}
